import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import { customerSchema } from 'schema';
import { FormHelperText, FormLabel, Input, Box, Stack } from '@mui/material';
import { patchApi } from 'views/services/api';
import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { Upload, Person, Phone, Email, Badge as BadgeIcon, Home } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';

const EditCustomer = (props) => {
  const { open, handleClose, data } = props;
  const [show, setShow] = useState(false);
  const [showIdFile2, setshowIdFile2] = useState(false);
  const theme = useTheme();

  const initialValues = {
    phoneNumber: data?.phoneNumber || '',
    firstName: data?.firstName || '',
    lastName: data?.lastName || '',
    email: data?.email || '',
    idCardType: data?.idCardType || 'default',
    idcardNumber: data?.idcardNumber || '',
    address: data?.address || '',
    idFile: null,
    idFile2: null
  };

  const EditData = async (values, resetForm) => {
    try {
      const formData = new FormData();
      formData.append('firstName', values.firstName);
      formData.append('lastName', values.lastName);
      formData.append('phoneNumber', values.phoneNumber);
      formData.append('email', values.email);
      formData.append('idCardType', values.idCardType);
      formData.append('idcardNumber', values.idcardNumber);
      formData.append('address', values.address);
      formData.append('idFile', values.idFile);
      formData.append('idFile2', values.idFile2);

      let response = await patchApi(`api/customer/editcustomer/${data?._id}`, formData);
      if (response.status === 200) {
        toast.success('Cliente actualizado correctamente');
        resetForm();
        setShow(false);
        setshowIdFile2(false);
        handleClose();
      } else {
        toast.error(response?.response?.data?.error || 'Error al modificar');
      }
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error al modificar');
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: customerSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      EditData(values, resetForm);
    }
  });

  const showFile = () => setShow(true);
  const showFile2 = () => setshowIdFile2(true);

  useEffect(() => {
    formik.setFieldValue('idFile', data?.idFile || null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Dialog 
      open={open} 
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }
      }}
    >
      <DialogTitle
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 2
        }}
      >
        <Typography variant="h5" fontWeight="600">Editar Cliente</Typography>
        <Button onClick={handleClose} sx={{ color: 'white', opacity: 0.8, '&:hover': { opacity: 1, bgcolor: 'rgba(255,255,255,0.1)' } }}>
          Cancelar
        </Button>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 4 }}>
        <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
          <Grid container rowSpacing={3.5} columnSpacing={{ xs: 0, sm: 3, md: 4 }}>
            
            <Grid item xs={12} sm={6}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Phone fontSize="small" color="primary" />
                <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Número de Teléfono</FormLabel>
              </Stack>
              <TextField
                id="phoneNumber"
                name="phoneNumber"
                size="medium"
                type="number"
                fullWidth
                placeholder="Ej. 1234567890"
                value={formik.values.phoneNumber}
                onChange={(e) => {
                  const phoneNumber = e.target.value.replace(/\D/g, '').slice(0, 10);
                  formik.setFieldValue(`phoneNumber`, phoneNumber);
                }}
                error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Person fontSize="small" color="primary" />
                <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Nombre</FormLabel>
              </Stack>
              <TextField
                id="firstName"
                name="firstName"
                size="medium"
                fullWidth
                placeholder="Ingresar Nombre"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Person fontSize="small" color="primary" />
                <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Apellido</FormLabel>
              </Stack>
              <TextField
                id="lastName"
                name="lastName"
                size="medium"
                fullWidth
                placeholder="Ingresar Apellido"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                helperText={formik.touched.lastName && formik.errors.lastName}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Email fontSize="small" color="primary" />
                <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Correo Electrónico</FormLabel>
              </Stack>
              <TextField
                id="email"
                name="email"
                size="medium"
                fullWidth
                value={formik.values.email}
                placeholder="correo@ejemplo.com"
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <BadgeIcon fontSize="small" color="primary" />
                <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Tipo de Documento</FormLabel>
              </Stack>
              <Select
                id="idCardType"
                name="idCardType"
                size="medium"
                fullWidth
                value={formik.values.idCardType}
                onChange={formik.handleChange}
                error={formik.touched.idCardType && Boolean(formik.errors.idCardType)}
                sx={{ borderRadius: 2 }}
              >
                <MenuItem value="default" disabled>Seleccionar Tipo</MenuItem>
                <MenuItem value="ID">Cédula de Identidad</MenuItem>
                <MenuItem value="Passport">Pasaporte</MenuItem>
                <MenuItem value="Rif">RIF</MenuItem>
                <MenuItem value="DrivingLicense">Licencia de Conducir</MenuItem>
              </Select>
              <FormHelperText error={formik.touched.idCardType && formik.errors.idCardType}>
                {formik.touched.idCardType && formik.errors.idCardType}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <BadgeIcon fontSize="small" color="primary" />
                <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Número de Documento</FormLabel>
              </Stack>
              <TextField
                id="idcardNumber"
                name="idcardNumber"
                size="medium"
                type="text"
                fullWidth
                placeholder="Ingresar número"
                value={formik.values.idcardNumber}
                onChange={formik.handleChange}
                error={formik.touched.idcardNumber && Boolean(formik.errors.idcardNumber)}
                helperText={formik.touched.idcardNumber && formik.errors.idcardNumber}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormLabel sx={{ fontWeight: 600, color: 'text.primary', display: 'block', mb: 1 }}>Documento Frente</FormLabel>
              {show ? (
                <Box sx={{ p: 2, border: '1px dashed #ccc', borderRadius: 2, bgcolor: '#f9f9f9' }}>
                  <Input
                    id="idFile"
                    name="idFile"
                    type="file"
                    disableUnderline
                    onChange={(event) => formik.setFieldValue('idFile', event.currentTarget.files[0])}
                  />
                </Box>
              ) : (
                <Button 
                  variant="outlined" 
                  startIcon={<Upload />} 
                  onClick={showFile}
                  sx={{ borderRadius: 2, py: 1.5, textTransform: 'none' }}
                  fullWidth
                >
                  Cambiar Frente del Doc.
                </Button>
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormLabel sx={{ fontWeight: 600, color: 'text.primary', display: 'block', mb: 1 }}>Documento Reverso</FormLabel>
              {showIdFile2 ? (
                <Box sx={{ p: 2, border: '1px dashed #ccc', borderRadius: 2, bgcolor: '#f9f9f9' }}>
                  <Input
                    id="idFile2"
                    name="idFile2"
                    type="file"
                    disableUnderline
                    onChange={(event) => formik.setFieldValue('idFile2', event.currentTarget.files[0])}
                  />
                </Box>
              ) : (
                <Button 
                  variant="outlined" 
                  startIcon={<Upload />} 
                  onClick={showFile2}
                  sx={{ borderRadius: 2, py: 1.5, textTransform: 'none' }}
                  fullWidth
                >
                  Cambiar Reverso del Doc.
                </Button>
              )}
            </Grid>

            <Grid item xs={12}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Home fontSize="small" color="primary" />
                <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Dirección Física</FormLabel>
              </Stack>
              <TextField
                id="address"
                name="address"
                size="medium"
                fullWidth
                placeholder="Ingresar Dirección Completa"
                value={formik.values.address}
                onChange={formik.handleChange}
                error={formik.touched.address && Boolean(formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            </Grid>
          </Grid>

          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button 
              onClick={handleClose} 
              variant="outlined" 
              color="inherit" 
              sx={{ borderRadius: 2, textTransform: 'none', px: 3 }}
            >
              Cancelar
            </Button>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              sx={{ borderRadius: 2, textTransform: 'none', px: 4, fontWeight: 600 }}
            >
              Guardar Cambios
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

EditCustomer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};

export default EditCustomer;
